import {
  HIDE_INFO_MODAL,
  HIDE_LOADER,
  HIDE_MISC_MODAL,
  NEXT_STEP,
  PREVIOUS_STEP,
  SHOW_INFO_MODAL,
  SHOW_LOADER,
  SHOW_MISC_MODAL,
} from "../actions/actionTypes";

const initialState = {
  currentStep: 0,

  infoModalType: "",
  isInfoModalVisible: false,
  infoModalContent: "",

  miscModalType: "",
  isMiscModalVisible: false,
  miscModalContent: "",

  isLoaderVisibile: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };

    case PREVIOUS_STEP:
      return {
        ...state,
        currentStep: state.currentStep - 1,
      };

    case SHOW_INFO_MODAL:
      return {
        ...state,
        isInfoModalVisible: true,
        infoModalType: action.payload.type,
        infoModalContent: action.payload.content,
      };

    case HIDE_INFO_MODAL:
      return {
        ...state,
        isInfoModalVisible: false,
        infoModalType: "",
        infoModalContent: "",
      };

    case SHOW_MISC_MODAL:
      return {
        ...state,
        isMiscModalVisible: true,
        miscModalType: action.payload.type,
        miscModalContent: action.payload.content,
      };

    case HIDE_MISC_MODAL:
      return {
        ...state,
        isMiscModalVisible: false,
        miscModalType: "",
        miscModalContent: "",
      };

    case SHOW_LOADER:
      return {
        ...state,
        isLoaderVisibile: true,
      };

    case HIDE_LOADER:
      return {
        ...state,
        isLoaderVisibile: false,
      };

    default:
      return state;
  }
}
